import React from 'react';
import useTheme from 'branding/theme';
import handleStickyFocus from '../../utils/handleStickyFocus';
/** invisible, read by screen readers */
const AccessiblyHiddenChoice = React.forwardRef(({ id, type, name, value, role, disabled, onChange, onClick, isHovered, handleMouseEnter, handleMouseLeave, handleTouchEnd, onFocus, onBlur, handleBlur, noTab }, ref) => {
    // used only to eliminate sticky focus on mouse click
    const handleClick = handleStickyFocus(handleBlur);
    const { utility: { accessiblyHidden, cursor: { pointer, notAllowed }, size: { fullSize } } } = useTheme();
    const mergedStyles = {
        ...accessiblyHidden,
        ...fullSize,
        ...(isHovered && pointer),
        ...(disabled && notAllowed),
        margin: 0
    };
    return (React.createElement("input", { type: type, name: name, id: id || value || name, disabled: disabled, style: mergedStyles, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onTouchEnd: handleTouchEnd, onFocus: onFocus, onBlur: onBlur, onChange: onChange, ref: ref, 
        // because keyboard also triggers click events, and
        // we only want to handle mouse clicks with these 2
        onMouseUp: handleClick, ...(onClick && { onMouseDown: onClick }), ...(value && { value }), ...(role === 'option' && { role }), ...(noTab && { tabIndex: -1 }) }));
});
export default AccessiblyHiddenChoice;
//# sourceMappingURL=index.js.map